import React from 'react'

import Icon from '../data/icon.png';
const Entete = () => {
    return (
        <div className="flex justify-between gap-3">
            <div className="flex flex-col gap-3">
                <h1>Complexe Scolaire privé SEBIL NEJAH</h1>
                <h1>Primaire-Collège-Secondaire</h1>
                <h2>Tel: 33882288-36184016-48611146</h2>
            </div>
            <img className="mx-auto h-28 w-auto" src={Icon} alt="Your Company" />
            <div className="flex flex-col text-right gap-3">
                <h1>المجمع المدرسي الخاص سبيل النجاح</h1>
                <h1>   ابتدائية - إعدادية - ثانوية </h1>
                <h2> 33882288-36184016-48611146: الهاتف</h2>
            </div>
        </div>
    )
}

export default Entete